import {} from "googlemaps";
import { Component, OnInit } from "@angular/core";
import data_perfect from "../../../../assets/location/Perfect_locs.json";
import data_coffee from "../../../../assets/location/Seattle_locs.json";
import data_motherland from "../../../../assets/location/Motherland_loc.json";
import data_ngf from "../../../../assets/location/Norman_loc.json";
import data_treger from "../../../../assets/location/Treger_locs.json"
@Component({
  selector: "app-,map-location",
  template: require('./map-location.component.html'),
  styles: [require('./map-location.component.css')],
})
export class MapLocation implements OnInit {
  docTheme = document.getElementById("theme-css");
  docLayout = document.getElementById("layout-css");
  programId: number;

  constructor() {
    this.programId = parseInt(sessionStorage.getItem("programID")); //this._applicationService.preAuthenticationResponse.programId;
  }

  homeBool = false;
  closestMarkerDict = { ShopName: "Distance" };

  lat: number;
  lng: number;

  shortCode: string;
  locIcon: string;
  loyaltyCompany: string;
  iconUrlCurrent: string;
  iconUrlLocation: string;
  iconUrlClosest: string;
  icons: any;
  ClosestMarker: string;
  legend: any;

  map_one: google.maps.Map;
  directionsService: any;
  directionsRenderer: any;

  data: any;
  zoom = 14;

  /*if(window.location.href == pizzaUrl ){
    this.data = data_pizza;
    }
    else if(window.location.href == coffeeUrl) {
    this.data = data_coffee;
    }
    }*/

  Style = [
    {
      featureType: "poi",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
  ];
  options_loc = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  infoWindowOpened = null;
  previous_info_window = null;

  public onMapReady(e) {
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer();
    this.map_one = e;
    this.find_closest();
    this.legend = document.getElementById("legend");
    // tslint:disable-next-line: forin
    for (var key in this.icons) {
      var type = this.icons[key];
      var name = type.name;
      var icon = type.icon;
      var div = document.createElement("div");

      div.innerHTML =
        '<span><img src="' +
        icon +
        '" style="width: 25px; height: 25px; padding-right: 5px; vertical-align: bottom;"></span>' +
        '<span style="font-size: 16px;">' +
        name +
        "</span>";
      this.legend.appendChild(div);
    }
    this.map_one.controls[google.maps.ControlPosition.RIGHT_TOP].push(
      this.legend
    );
  }
  displayRoute(coffee_lat, coffee_lng) {
    this.removeRoute();

    // tslint:disable-next-line: prefer-const
    var start = new google.maps.LatLng(this.lat, this.lng);
    var end = new google.maps.LatLng(coffee_lat, coffee_lng);
    var request = {
      origin: start,
      destination: end,
      travelMode: google.maps.TravelMode.DRIVING,
      optimizeWaypoints: true,
    };

    this.directionsRenderer.setMap(this.map_one);
    // NEED TO CREATE NEW RENDER OBJECT SO CAN PASS INSIDE THE DIRECTIONSERVICE
    var Render = this.directionsRenderer;

    this.directionsService.route(request, function (result, status) {
      if (status === google.maps.DirectionsStatus.OK) {
        Render.setDirections(result);
      } else {
        console.log("Failed");
      }
    });
  }
  // REMOVE PREVIOUS  OLD ROUTE
  removeRoute() {
    this.directionsRenderer.setMap(null);
  }

  // ROAD DISTANCE
  dist_matrix(store_loc_lat, store_loc_lng) {
    var origin = new google.maps.LatLng(this.lat, this.lng),
      destination = new google.maps.LatLng(store_loc_lat, store_loc_lng),
      service = new google.maps.DistanceMatrixService();

    service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: google.maps.TravelMode.DRIVING,
        avoidHighways: false,
        avoidTolls: false,
      },
      callback
    );
    function callback(response, status) {
      if (status == "OK") {
        document.getElementById("dist_p").innerHTML =
          "Distance: " + response.rows[0].elements[0].distance.text;
      } else {
        console.log("error @ req for dist");
      }
    }
  }
  //Distance straight line
  //Optimize client side instead of using dist_matrix

  culc_dist(store_loc_lat, store_loc_lng, store_str_name) {
    var user_loc = new google.maps.LatLng(this.lat, this.lng);
    var store_loc = new google.maps.LatLng(store_loc_lat, store_loc_lng);
    var distance = google.maps.geometry.spherical.computeDistanceBetween(
      user_loc,
      store_loc
    );
    this.closestMarkerDict[store_str_name] = distance;
  }

  find_closest() {
    for (let item of this.data) {
      this.culc_dist(item.Lat, item.Lng, item.ShopName);
    }

    var keys = Object.values(this.closestMarkerDict);
    keys.shift();
    var match;
    var lowest = Math.min.apply(null, keys);
    var items;
    for (let [key, value] of Object.entries(this.closestMarkerDict)) {
      if (value === lowest) {
        match = key;
      }
    }

    this.ClosestMarker = match;

    var marker = document.getElementById(match);
    if (marker) {
      marker.parentNode.removeChild(marker);
      
    }
  }

  ngOnInit() {
    this.getUserLocation();

    this.shortCode = process.env.program;
    if (this.shortCode === "sc" || this.shortCode === 'scbn') {
      this.locIcon = "Seattle";
      this.loyaltyCompany = "Seattle Coffee";
      this.data = data_coffee["data"].map((location) => ({
        ...location,
        Lat: parseFloat(location.Lat),
        Lng: parseFloat(location.Lng),
      }))
    }else if(this.shortCode === 'mc'){
      this.locIcon = "Motherland";
      this.loyaltyCompany = "Motherland Coffee";
      this.data = data_motherland["data"].map((location) => ({
        ...location,
        Lat: parseFloat(location.Lat),
        Lng: parseFloat(location.Lng),
      }));
    }else if(this.shortCode === 'treg'){
      this.locIcon = "Treger";
      this.loyaltyCompany = "Time & Co";
      this.data = data_treger["data"].map((location) => ({
        ...location,
        Lat: parseFloat(location.Lat),
        Lng: parseFloat(location.Lng),
      }));
    }

    this.icons = {
      current: {
        name: "Your Location",
        icon: `./assets/location/${this.locIcon}_current.png`,
      },
      location: {
        name: `${this.loyaltyCompany} Shop`,
        icon: `./assets/location/${this.locIcon}_location.png`,
      },
      closest: {
        name: `Closest ${this.loyaltyCompany} Shop`,
        icon: `./assets/location/${this.locIcon}_closest.png`,
      },
    };

    this.iconUrlClosest = `./assets/location/${this.locIcon}_closest.png`;
    this.iconUrlCurrent = `./assets/location/${this.locIcon}_current.png`;
    this.iconUrlLocation = `./assets/location/${this.locIcon}_location.png`;
  }

  markerClick(coffee_lat, coffee_lng, infoWindow) {
    this.checkOpen(infoWindow);
    this.dist_matrix(coffee_lat, coffee_lng);
  }

  checkOpen(infoWindow) {
    if (this.previous_info_window == null) {
      this.previous_info_window = infoWindow;
    } else {
      this.infoWindowOpened = infoWindow;
      this.previous_info_window.close();
    }
    this.previous_info_window = infoWindow;
  }

  error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  getUserLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
        },
        this.error,
        this.options_loc
      );
    }
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/map-location/map-location.component.ts